import { render, staticRenderFns } from "./documents.accountspayableFileAuto.vue?vue&type=template&id=16674b1c&scoped=true"
import script from "./documents.accountspayableFileAuto.vue?vue&type=script&lang=js"
export * from "./documents.accountspayableFileAuto.vue?vue&type=script&lang=js"
import style0 from "./documents.accountspayableFileAuto.vue?vue&type=style&index=0&id=16674b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16674b1c",
  null
  
)

export default component.exports